// JavaScript source code
export const PersonaFisicaTitularMock = {
    EsPersonaFisica: true,
    Titular: true,
    Nombre: "Pablo",
    Apellido: "Cardenas Robles",
    RazonSocial: "Delocho Elchavo S.A.",
    TipoDocumento: {
        Codigo: 1

    },
    NumDocumento:"11111111",
    CUIT: "11-11111111-1",
    Sexo: "Masculino",
    FechaNacimiento: "11/11/1111",
    Nacionalidad: "Argentino",
    EstadoCivil: "Soltero",
    Ocupacion: "Arquitecto",
    CondicionIVA:"XXXXXXXX"
}
export const PersonaFisicaAdicionalMock = {
    EsPersonaFisica: true,
    Titular: false,
    Nombre: "JOSE",
    Apellido: "Robles Dominguez",
    RazonSocial: "Delocho Elchavo S.A.",
    TipoDocumento: {
        Codigo: 1

    },
    NumDocumento: "11111111",
    CUIT: "11-11111111-1",
    Sexo: "Masculino",
    FechaNacimiento: "11/11/1111",
    Nacionalidad: "Argentino",
    EstadoCivil: "Soltero",
    Ocupacion: "Arquitecto",
    CondicionIVA: "XXXXXXXX"
}
export const PersonaJuridicaMock = {
    EsPersonaFisica: false,
    Titular: true,
    Nombre: "Persona",
    Apellido: "Juridica",
    RazonSocial: "Delocho Elchavo S.A.",
    TipoDocumento: {
        Codigo: 1
 
    },
    Sexo:"E",
    NumDocumento: "11111111",
    CUIT: "11-11111111-1",
    Nacionalidad: "Argentino",
    Ocupacion: "otro",
    CondicionIVA: "XXXXXXXX",
    CondicionImpuestoGanancias:"XXXXXXXX",
    CondicionIngresosBrutos: "XXXXXXXX"

}